import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import SessionExpiredToast from './components/SessionExpiredToast/SessionExpiredToast';
import AnnouncementToast from './components/AnnouncementToast/AnnouncementToast';
import { AnnouncementsProvider } from './context/AnnouncementsProvider';
import Login from './pages/Login/Login';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import UpdatePassword from './pages/UpdatePassword/UpdatePassword';
import RecoveryLogin from './pages/RecoveryLogin/RecoveryLogin';
import Assets from './pages/Dashboard/Assets/Assets';
import Leaderboard from './pages/Dashboard/Leaderboard/Leaderboard';
import AccountSettings from './pages/Dashboard/AccountSettings/AccountSettings';
import Overview from './pages/Dashboard/Overview/Overview';
import Team from './pages/Dashboard/Team/Team';
import Wallet from './pages/Dashboard/Wallet/Wallet';
import TradeCopier from './pages/Dashboard/TradeCopier/TradeCopier';
import RiskCockpit from './pages/Dashboard/RiskCockpit/RiskCockpit';
import HelpCenter from './pages/Dashboard/HelpCenter/HelpCenter';
import Announcements from './pages/Dashboard/Announcements/Announcements';
import PrivacyPolicy from './pages/Dashboard/PrivacyPolicy/PrivacyPolicy';
import TermsOfUse from './pages/Dashboard/TermsOfUse/TermsOfUse';

function AdminRoute({ element }) {
  const { isAdmin } = JSON.parse(localStorage.getItem('user') || '{}');
  return isAdmin ? element : <Navigate to="/dashboard/assets" replace />;
}

function App() {
  return (
    <BrowserRouter>
      {/* Inside the router: the provider watches the route to know whether the
          channel is already open, and the toast navigates to it. */}
      <AnnouncementsProvider>
        <SessionExpiredToast />
        <AnnouncementToast />
        <Routes>
          <Route path="/login"            element={<Login />} />
          <Route path="/forgot-password"  element={<ForgotPassword />} />
          <Route path="/update-password"  element={<UpdatePassword />} />
          <Route path="/recovery-login"   element={<RecoveryLogin />} />

          {/* Admin-only routes */}
          <Route path="/dashboard/overview"     element={<AdminRoute element={<Overview />} />} />
          <Route path="/dashboard/risk-cockpit" element={<AdminRoute element={<RiskCockpit />} />} />
          <Route path="/dashboard/team"         element={<AdminRoute element={<Team />} />} />

          {/* All authenticated users */}
          <Route path="/dashboard/assets"          element={<Assets />} />
          <Route path="/dashboard/wallet"          element={<Wallet />} />
          <Route path="/dashboard/leaderboard"     element={<Leaderboard />} />
          <Route path="/dashboard/trade-copier"    element={<TradeCopier />} />
          <Route path="/dashboard/help"            element={<HelpCenter />} />
          <Route path="/dashboard/announcements"   element={<Announcements />} />
          <Route path="/dashboard/account-settings" element={<AccountSettings />} />
          <Route path="/dashboard/privacy"         element={<PrivacyPolicy />} />
          <Route path="/dashboard/terms"           element={<TermsOfUse />} />

          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AnnouncementsProvider>
    </BrowserRouter>
  );
}

export default App;
